var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',_vm._l((_vm.history.length),function(index){return _c('app-history',{key:index,attrs:{"index":index - 1,"item":_vm.history[index - 1]},on:{"removeRequest":_vm.removeRequest}},[_vm._v(". ")])}),1),_c('app-dialog',{on:{"close":_vm.onCloseDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }